module.exports = __webpack_public_path__ + "static/media/guide_simple.d6c99cb8.png";